import { AlertTriangle, X } from 'lucide-react';
import { getPlatformLabel } from '../types/socialMedia.types';

export const DeleteSocialMediaModal = ({ isOpen, onClose, onConfirm, link, isLoading }) => {
  if (!isOpen || !link) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center'>
      <div className='absolute inset-0 bg-black/60 backdrop-blur-sm' onClick={onClose} />
      <div className='relative z-10 w-full max-w-sm mx-4 bg-card border border-border rounded-xl shadow-2xl'>
        <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
          <h2 className='text-lg font-semibold text-foreground'>Delete Link</h2>
          <button onClick={onClose} className='p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors'>
            <X size={18} />
          </button>
        </div>
        <div className='px-6 py-5'>
          <div className='flex items-start gap-3'>
            <div className='p-2 rounded-full bg-red-900/20 border border-red-900/30 shrink-0'>
              <AlertTriangle size={20} className='text-red-400' />
            </div>
            <div>
              <p className='text-sm text-foreground font-medium'>
                Are you sure you want to delete the{' '}
                <span className='text-primary'>{getPlatformLabel(link.platform)}</span> link?
              </p>
              <p className='text-xs text-muted-foreground mt-1 break-all'>{link.link}</p>
              <p className='text-xs text-muted-foreground mt-2'>This action cannot be undone.</p>
            </div>
          </div>
        </div>
        <div className='flex items-center justify-end gap-3 px-6 py-4 border-t border-border'>
          <button onClick={onClose} className='px-4 py-2 text-sm text-muted-foreground border border-border rounded-md hover:bg-accent transition-colors'>
            Cancel
          </button>
          <button
            onClick={() => onConfirm(link._id)}
            disabled={isLoading}
            className='px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};